import { z } from "zod";

export const MiembroJuntaSchema = z.object({
  tipoDocumento: z
    .string({
      required_error: "Seleccione tipo de documento",
    })
    .min(1, "Seleccione tipo de documento")
    .nonempty("Campo obligatorio"),
  numeroDocumento: z
    .string({
      required_error: "Ingrese número de documento",
    })
    .min(1, "Ingrese número de documento"),
  nombreCompleto: z
    .string({ required_error: "Ingrese nombre completo o razón social" })
    .min(1, "Ingrese nombre completo o razón social"),
  telefono: z
    .string()
    .min(7, "El teléfono debe tener mínimo 7 dígitos")
    .regex(/^[0-9]+$/, "El teléfono solo debe contener números"),
  pais: z
    .string({
      required_error: "El pais es obligatorio",
    })
    .min(1, "El pais es obligatorio"),
  departamento: z.string().optional(),
  ciudad: z.string().optional(),
});

export const JuntaDirectivaSchema = z.object({
  miembros: z.array(MiembroJuntaSchema).optional(),
});

export type JuntaDirectivaFormValues = z.infer<typeof JuntaDirectivaSchema>;
